<template>
    <div>
        <Header title="我的文章"/>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight- 60) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <myArticleItem v-for="(item, index) in dataSources" :key="index" :item="item"/>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
        <div class="footer" @click="onPressNav('articlePublish')">发布文章</div>
    </div>
</template>

<script>
import Header from '@/components/Header'
import myArticleItem from '@/components/item/myArticleItem'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
        'myArticleItem': myArticleItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 0,
            limit: 10,
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        // 页面跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求数据
        async requestData() {
            let url = this.API.article_list;
            let params = {
                
                page_index: this.page,
                page_size: this.limit,
            };
            let result = await this.$get(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.list;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.list;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSources = dataSourcesTemp
                that.$refs.infinite.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>

.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.footer {
    margin: 10px 15px;
    height: 40px;
    background: linear-gradient(225deg,#9cb2f4, #6472e8);
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #fff;
}
</style>